import { useState } from "react"

import {
  OBJECT_VIEW_MODE,
  SIMULATION_INPUT_VIEW_MODE,
  type ObjectViewMode,
  type SimulationInputViewMode,
} from "@/lib/viewModes"

export function useViewModes() {
  const [metadataViewMode, setMetadataViewMode] = useState<ObjectViewMode>(
    OBJECT_VIEW_MODE.COLUMNS,
  )
  const [simulationInputViewMode, setSimulationInputViewMode] =
    useState<SimulationInputViewMode>(SIMULATION_INPUT_VIEW_MODE.TEXT)

  return {
    metadataViewMode,
    setMetadataViewMode,
    simulationInputViewMode,
    setSimulationInputViewMode,
  }
}
